export default "__VITE_ASSET__DsBgMC2e__"